/* -------------------------------------------------------------- attention */
.attention {
  display: grid;
  gap: var(--space-3);
}

.attentionCard {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  padding: var(--space-4);
  background: var(--warning-soft);
  border: 1px solid var(--warning);
  border-left-width: 3px;
  border-radius: var(--radius);
}

.attentionCount {
  font-size: var(--text-2xl);
  font-weight: var(--weight-bold);
  color: var(--warning);
  font-variant-numeric: tabular-nums;
  line-height: 1;
  flex-shrink: 0;
  min-width: 2ch;
  text-align: center;
}

.attentionText { flex: 1; min-width: 0; }

.attentionLabel {
  font-weight: var(--weight-medium);
  color: var(--text);
}

.attentionDetail {
  font-size: var(--text-sm);
  color: var(--text-muted);
  margin-top: 2px;
}

.attentionAction {
  flex-shrink: 0;
  font-size: var(--text-sm);
  font-weight: var(--weight-medium);
  color: var(--warning);
  white-space: nowrap;
}

/* ---------------------------------------------------------------- metrics */
.metricGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--space-4);
}

.metric {
  padding: var(--space-4) var(--space-5);
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  border-top: 3px solid var(--border-strong);
}

/* Accent only on the two metrics that answer "is the business working?" */
.metric.indigo { border-top-color: var(--indigo); }
.metric.teal   { border-top-color: var(--teal); }

.metricLabel {
  font-size: var(--text-xs);
  font-weight: var(--weight-medium);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
}

.metricValue {
  margin-top: var(--space-2);
  font-size: var(--text-2xl);
  font-weight: var(--weight-bold);
  line-height: 1.1;
  color: var(--text);
}

.metricHint {
  margin-top: var(--space-1);
  font-size: var(--text-xs);
  color: var(--text-subtle);
}

.metricSkeleton {
  display: block;
  margin-top: var(--space-2);
  height: 30px;
  width: 60%;
  border-radius: var(--radius-sm);
  background: linear-gradient(
    90deg,
    var(--bg-sunken) 25%,
    var(--bg-hover) 50%,
    var(--bg-sunken) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.4s ease-in-out infinite;
}

@keyframes shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ----------------------------------------------------------------- layout */
.twoColumn {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: var(--space-5);
  align-items: start;
}

/* ------------------------------------------------------------------ stats */
.statList {
  display: flex;
  flex-direction: column;
}

.stat {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-3) 0;
  border-bottom: 1px solid var(--border);
}

.stat:last-child { border-bottom: none; }
.stat:first-child { padding-top: 0; }

.statLabel {
  display: flex;
  flex-direction: column;
  color: var(--text-muted);
  font-size: var(--text-sm);
}

.statHint {
  font-size: var(--text-xs);
  color: var(--text-subtle);
  margin-top: 2px;
}

.statValue {
  font-weight: var(--weight-semibold);
  color: var(--text);
  white-space: nowrap;
}

/* ------------------------------------------------------------------ misc */
.mentorName { font-weight: var(--weight-medium); }

.ratingCount {
  color: var(--text-subtle);
  font-weight: var(--weight-normal);
  font-size: var(--text-xs);
}

.muted {
  color: var(--text-muted);
  font-size: var(--text-sm);
}

.errorText {
  color: var(--danger);
  font-size: var(--text-base);
}

@media (max-width: 640px) {
  .attentionCard {
    flex-wrap: wrap;
    gap: var(--space-3);
  }
}
